{
	"dashboard": "Dashboard",
	"recoveryContainer": {
		"footerText": "© 2026 Zig The Global Funtech. Todos os direitos reservados."
	},
	"newLogin": {
		"heroTitle": {
			"prefix": "A Zig organiza",
			"suffix": "o ritmo do seu",
			"words": ["show", "consumo", "evento", "festival", "pub"]
		},
		"labels": {
			"company": "Organização",
			"login": "Login",
			"password": "Senha"
		},
		"description": "Para acessar, preencha os dados",
		"fields": {
			"organization": {
				"placeholder": "Digite o nome da organização",
				"required": "O nome da organização é requerido"
			},
			"username": {
				"placeholder": "Digite seu login",
				"required": "Seu login é requerido"
			},
			"password": {
				"placeholder": "Digite sua senha",
				"required": "Sua senha é requerida"
			}
		},
		"submit": "Entrar",
		"forgotPassword": {
			"question": "Esqueceu a senha?",
			"action": "Clique aqui"
		}
	}
}
